



























import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Ref} from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'
import { MutationTypes, MessageListModes } from '@/modules/i18n/store/mutations'
import Message from '@/modules/i18n/model/Message'
import Locale from '@/modules/i18n/model/Locale'
import MessageTranslation from '@/modules/i18n/model/MessageTranslation'

/**
 * Mensaje mostrado en la lista de mensajes
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MessageItem extends Vue {
    @Prop({required: true, type: Object})
    public value: Message

    /**
     * Localismo seleccionado actualmente por el usuario, se utiliza para
     * mostrar una determinada traducción
     */
    @Getter('i18n/currentLocale')
    public currentLocale: Locale | null

    @Mutation(`i18n/${MutationTypes.SetMessageListSelectedMessage}`)
    public selectMessage: (payload: {message: Message | null}) => void


    @Mutation(`i18n/${MutationTypes.SetLocaleMessageMode}`)
    public setMode: (payload: {mode: MessageListModes}) => void

    /**
     * Referencia al contenedor que muestra el contenido del mensaje. Utilizada
     * para re-dimensionar el contenedor cuando el tamaño de pantalla
     * cambia
     */
    @Ref('cardText')
    public cardText: HTMLDivElement

    /**
     * Traducción actualmente seleccionada
     */
    get messageTranslation (): MessageTranslation | null {
        if (!this.currentLocale) {
            return null
        }

        return this.value.translate(this.currentLocale.identifier)
    }

    public editMessage (message: Message): void {
        this.setMode({ mode: MessageListModes.Editing })
        this.selectMessage({ message: _.clone(message) })
    }

    public onDelete (message: Message) {
        this.setMode({mode: MessageListModes.Deleting})
        this.selectMessage({message})
    }

    /**
     * Cuando el componente es insertado en el DOM se añade un suscriptor al evento "resize"
     * que calcula el alto de la tarjeta para que esta siempre mantenga una relación
     * aspecto cuadrada.
     */
    public mounted () {
        this.calculateItemHeight()
        window.addEventListener('resize', this.calculateItemHeight)
    }

    /**
     * Elimina la suscripción al evento para evitar fugas de memoria
     */
    public destroyed () {
        window.removeEventListener('resize', this.calculateItemHeight)
    }

    /**
     * Calcula el alto del contenedor que muestra el contenido del mensaje para que
     * su relación de aspecto siempre sea cuadrada en cualquier tamaño de
     * pantalla
     */
    public calculateItemHeight () {
        const el = this.$el as HTMLDivElement
        const cardText = this.cardText
        if (!el || !cardText) {
            return
        }

        cardText.style.height = `${el.offsetWidth - 200}px`
    }
}
